// Copyright (c) 2017 Deere & Company

import actions from '../../actions-list';

export const closeModal = () =>

    dispatch => {

        document.body.classList.remove('warranty-modal-is-open');

        dispatch({
            type: actions.CLOSE_TCSM_LABOR_RATE_MODAL
        });

    };

export const openModal = actionToTake =>

    dispatch => {

        document.body.classList.add('warranty-modal-is-open');

        dispatch({
            data: actionToTake,
            type: actions.OPEN_TCSM_LABOR_RATE_MODAL
        });

    };



// WEBPACK FOOTER //
// ./src/tcsm/labor-rate-approval/action-creators/modal.js